export const CHANGE_SALE_DATA = 'CHANGE_SALE_DATA';

export const changeSaleData = (typeSale, obj) => {
    return async (dispatch) => {
        dispatch({ type: CHANGE_SALE_DATA, payload: {typeSale: typeSale, obj: obj} });
    };
};
